module.exports = __webpack_public_path__ + "img/lock.23396880.svg";